import { Injectable, Optional } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FarrisSidebarService } from '@farris/ui-sidebar';
import { Entity, FrameContext } from '@farris/devkit';
import { BefRepository } from '@farris/bef';
import { FormMessageService } from './form-message.service';
import { LanguageService } from './languag.service';
import { DataChangeDetectionService } from './data-change-detection.service';


/**
 * ä¾§è¾¹æ æå¡
 * @scope FrameComponent
 */
@Injectable()
class SidebarService {

  private get repository(): BefRepository<Entity> {
    return this.frameContext.repository as BefRepository<Entity>;
  }

  constructor(
    private frameContext: FrameContext,
    private sidebarUIService: FarrisSidebarService,
    private messageService: FormMessageService,
    @Optional() private languageService: LanguageService,
  ) {
    if (!this.languageService) {
      this.languageService = LanguageService.getInstance();
    }
  }

  openSidebar() {
    this.sidebarUIService.sendIsOpen(true);
  }

  closeSidebar() {
    this.sidebarUIService.sendIsOpen(false);
  }

  /**
   * å³é­åååæ¶åæ´
   */
  confirmBeforeClosingSidebar(): Observable<boolean> {
    // æ£æ¥æ¯å¦æåæ´ï¼æ²¡æåæ´ç´æ¥å³é­
    // const ifChangesExist = this.repository.entityManager.checkAllEntityChanges();
    // if (!ifChangesExist) {
    //   return of(true);
    // }
    const hasChange$ = DataChangeDetectionService.hasChange(this.frameContext);
    return hasChange$.pipe(
      switchMap((hasChange: boolean) => {
        if (!hasChange) {
          return of(true);
        } else {
          // ç¡®è®¤æ¯å¦å³é­
          const confirm$ = this.messageService.question(this.languageService['exitWithoutSave']);
          return confirm$.pipe(
            switchMap((confirmResult: boolean) => {
              if (confirmResult === false) {
                return of(false);
              } else {
                return of(true);
              }
            })
          );
        }
      })
    );
  }

  /**
   * ç»§ç»­å³é­ä¾§è¾¹æ 
   */
  public continueClosingSidebar(): Observable<boolean> {
    return of(true);
  }

  /**
   * é»æ­¢ä¾§è¾¹æ å³é­
   */
  public stopClosingSidebar(): Observable<boolean> {
    return of(false);
  }
}

export { SidebarService };
